import { useEffect, useState } from "react";
import api from "@/shared/lib/api";

// Global project reference: shows the assigned UPR number, falls back to the
// temporary MIPL-2026-XXXX code until a UPR is set. Cached once per session.
let cache = null;
let promise = null;
const listeners = new Set();

function load() {
  promise = promise || api.get("/upr-map")
    .then((r) => { cache = r.data || {}; listeners.forEach((fn) => fn()); })
    .catch(() => { cache = {}; });
  return promise;
}

export function refreshUprMap() { cache = null; promise = null; load(); }

export function ProjRef({ code }) {
  const [, force] = useState(0);
  useEffect(() => {
    const fn = () => force((x) => x + 1);
    listeners.add(fn);
    if (!cache) load();
    return () => listeners.delete(fn);
  }, []);
  return <>{(cache && cache[code]) || code || ""}</>;
}

export default ProjRef;
